import base from './base.repository';
import { _url } from '../utils/http.util';

export default {
    ...base,
    getPaged(page = 1, filters) {
        const params = { ...filters, page };
        this.get(`quotation-items${this.querify(params)}`);
        return this;
    },
    getItem(id) {
        this.get(`quotation-items/${id}`);
        return this;
    },
    saveItem(payload) {
        this.post('quotation-items', payload);
        return this;
    },
    updateItem(payload, id) {
        this.put(`quotation-items/${id}`, payload);
        return this;
    },
    deleteItem(id) {
        this.delete(`quotation-items/${id}`);
        return this;
    },
    updateItemStatus(id, status) {
        this.patch(`quotation-items/${id}/status`, { status });
        return this;
    },
    getCategories() {
        this.get('quotation-items/categories');
        return this;
    },
    getItemCategorySettings(page = 1, filters) {
        const params = { ...filters, page };
        this.get(`quotation-settings${this.querify(params)}`);
        return this;
    },
    getItemCategorySetting(id) {
        this.get(`quotation-settings/${id}`);
        return this;
    },
    saveItemCategorySetting(payload) {
        this.post('quotation-settings', payload);
        return this;
    },
    updateItemCategorySetting(payload, id) {
        this.put(`quotation-settings/${id}`, payload);
        return this;
    },
    deleteItemCategorySetting(id) {
        this.delete(`quotation-settings/${id}`);
        return this;
    },
    importItems(formData) {
        this.postFormData('quotation-items/import', formData);
        return this;
    },
    getImportStatus(batchId) {
        this.get(`quotation-items/import/${batchId}/status`);
        return this;
    }
};

